module.exports = __webpack_public_path__ + "static/img/studefault.fe5f508.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/tic/studefault.png
// module id = iKXg
// module chunks = 0